const appInfo = {
	title: 'Artemis Fiber',
}
export default appInfo
